module.exports = __webpack_public_path__ + "img/genderEquality.9da33cf4.png";